import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconGlobeGeoStyle0 = cosmosIconCss;

const CosmosIconGlobeGeo$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconGlobeGeo extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '628bec018d232ecb6e2994bf82cd787b52e33520', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fc9d300a6aa555d6aeb9242b58ffd9d1fb844ed6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5b905e9bba9fdffc7d8383514111f3e80eb1b23d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 11a9 9 0 0 1 9-9 9.01 9.01 0 0 1 9 9 9 9 0 1 1-18 0Zm16.5 0a7.6 7.6 0 0 0-.135-1.425l-.879.948a.5.5 0 0 0-.133.34v1.08a.499.499 0 0 1-.013.113l-.348 1.502a.5.5 0 0 1-.25.327l-.426.23a.5.5 0 0 0-.25.327l-.27 1.17a.5.5 0 0 1-.487.388h-.058a.5.5 0 0 1-.477-.352l-.281-.91a.5.5 0 0 1-.022-.147v-1.147a.5.5 0 0 0-.047-.21l-.319-.69a.5.5 0 0 1-.046-.21v-.278a.5.5 0 0 0-.5-.5h-.635a.5.5 0 0 1-.193-.04l-1.038-.435a.5.5 0 0 1-.27-.275l-.8-2a.5.5 0 0 1 .11-.54l1.241-1.24a.496.496 0 0 1 .056-.048l1.415-1.05a.5.5 0 0 0 .202-.402v-.339a.5.5 0 0 1 .263-.44l.65-.35a7.466 7.466 0 0 0-3.684-.896l-1.087.624-.307.155a.376.376 0 0 0 .03.685.376.376 0 0 1 .233.405l-.223 1.48a.5.5 0 0 1-.123.262l-.513.567a.5.5 0 0 1-.371.165h-.33a.5.5 0 0 0-.5.5v.412a.5.5 0 0 1-.084.276l-.887 1.343a.5.5 0 0 0-.082.275v.412a.5.5 0 0 0 .5.5h.87a.5.5 0 0 1 .355.149l.65.656a.501.501 0 0 0 .582.094.501.501 0 0 1 .727.445v.044a.5.5 0 0 0 .145.352l1.218 1.23a.5.5 0 0 1 .12.509l-.366 1.106a.5.5 0 0 1-.25.29l-.592.3a.5.5 0 0 0-.275.446v.491a.263.263 0 0 1-.263.264.263.263 0 0 0-.264.263v.202A7.5 7.5 0 0 0 18.5 11ZM8.21 17.964v-1.946a.5.5 0 0 0-.144-.352l-1.219-1.23a.5.5 0 0 1-.12-.508l.312-.943a.5.5 0 0 0-.196-.572l-1.222-.822a.504.504 0 0 0-.089-.048l-2.026-.835a7.502 7.502 0 0 0 4.705 7.256Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconGlobeGeoStyle0; }
}, [1, "cosmos-icon-globe-geo", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-globe-geo"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-globe-geo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconGlobeGeo$1);
            }
            break;
    } });
}

const CosmosIconGlobeGeo = CosmosIconGlobeGeo$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconGlobeGeo, defineCustomElement };
